import { Controller } from '@hotwired/stimulus';
import { TurboMixin } from '../../../mixins/turbo_mixin';

/*
Generic controller for loading FSP payment accounts into select and turbo frame.
*/

export default class extends Controller {
  static values = {
    fetchUrl: String,
    turboFrameTagName: String,
    selectSelector: String,
  };

  initialize() {
    TurboMixin(this);
  }

  fetch_payment_accounts() {
    const select = document.querySelector(this.selectSelectorValue);

    this.turboGet(this.fetchUrlValue, {
      turbo_frame_table_id: this.turboFrameTagNameValue,
      select_id: select.id,
      ...this.additional_turbo_params?.(),
    });
  }
}
